import { initializeIcons } from "@fluentui/font-icons-mdl2";

initializeIcons();
